"use client"

import { useCallback } from "react"

import {
  shortenAddress,
  walletChains,
  type WalletModalLabels,
} from "../config"
import { useWalletChain } from "../context/wallet-context"
import { useTronWallet } from "./use-tron-wallet"

export function useWallet() {
  const { openWalletModal } = useWalletChain()
  const tron = useTronWallet()

  const resolvedAddress = tron.address
  const shortAddress = resolvedAddress ? shortenAddress(resolvedAddress) : null

  const openModal = useCallback(
    (labels?: Partial<WalletModalLabels>) => {
      openWalletModal(labels)
    },
    [openWalletModal],
  )

  const connect = useCallback(
    (labels?: Partial<WalletModalLabels>) => {
      openWalletModal(labels)
    },
    [openWalletModal],
  )

  const disconnect = useCallback(async () => {
    tron.disconnect()
  }, [tron])

  return {
    address: resolvedAddress ?? null,
    shortAddress,
    chain: walletChains.tron,
    activeChain: "tron" as const,
    isConnected: tron.isConnected,
    openModal,
    connect,
    disconnect,
  }
}
